import FrogSafeIframeView from './frogsafeiframe.js';

/**
 * SinglePageView - Base class for single-page rendering
 * Extends IframeView to add automatic centering and styling for single-page books
 * This replaces ALL the DOM manipulation from documentFix.ts for single-page books
 */
class SinglePageView extends FrogSafeIframeView {
  constructor(section, options) {
    super(section, options);
    this.hasSpreadNone = options.hasSpreadNone || false;
  }

  render(request, show) {
    return super.render(request, show).then(() => {
      // Apply single-page centering immediately when view is created
      // This prevents visual jumps during animations
      // Note: Colors are handled by fixPageColors() in documentFix which has theme access
      this.applySinglePageStyles();

      return this;
    });
  }

  /**
   * Apply horizontal centering for single-page content
   * This replaces the logic from documentFix.ts
   */
  applySinglePageStyles() {
    if (!this.contents || !this.contents.document || !this.contents.document.body) {
      return;
    }

    const body = this.contents.document.body;

    // Reset margins first (replaces the body margin:0 from documentFix)
    body.style.margin = '0';

    // Calculate horizontal centering offset
    const offset = this.calculateCenteringOffset();

    if (offset > 0) {
      // Apply horizontal centering immediately (inline style)
      // This replaces getDiffBetweenIframeAndBodyWidth logic from documentFix
      body.style.marginLeft = `${offset}px`;
    }
  }

  /**
   * Calculate horizontal centering offset
   * Replaces getDiffBetweenIframeAndBodyWidth from iframe-utils.js
   */
  calculateCenteringOffset() {
    if (!this.contents || !this.contents.document || !this.contents.document.body) {
      return 0;
    }

    const body = this.contents.document.body;
    const bodyRect = body.getBoundingClientRect();
    const iframeWidth = this.width();

    // Difference between iframe and body width
    const diff = iframeWidth - bodyRect.width;

    // Center by half the difference
    const offset = Math.max(0, diff / 2);

    return offset;
  }
}

export default SinglePageView;
